import React, { Component } from 'react';

import { MenuGroupAPI } from '@philips-emr/tws-components-api';
import { Direction } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, bool, element, expression, oneOf, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { enumValues, getLostProps, propagateProps } from '@philips-emr/tws-utils';

import './menu-group.scss';

const acceptedTypes = [
  ComponentType.NAVIGATION,
];

@AwesomeComponent({ type: ComponentType.NAVIGATION, api: MenuGroupAPI })
class MenuGroup extends Component {
  static propTypes = {
    children: arrayOf(element).notEnumerable(),
    title: expression,
    uuid: string,
    direction: oneOf(enumValues(Direction)).readOnly(),
    visible: bool,
  };

  static defaultProps = {
    visible: true,
  };

  renderOptions() {
    const { children, direction } = this.props;
    const lostProps = getLostProps(MenuGroup.propTypes, this.props);

    return propagateProps(children, { ...lostProps, direction });
  }

  render() {
    const { title, uuid, direction, visible } = this.props;
    const Container = ContainerProvider.provide(this);

    if (!visible) {
      return null;
    }

    if (direction === Direction.VERTICAL) {
      return this.renderOptions();
    }

    return (
      <Container acceptedTypes={acceptedTypes} className="c-menu-group"  uuid={uuid} x-contrast="bg">
        {title &&
        <div className="c-menu-group__title" x-contrast="bg">{msg(title)}</div>}

        <div className="c-menu-group__content">
          {this.renderOptions()}
        </div>
      </Container>
    );
  }
}

export default MenuGroup;
